export const placeholderMapping: Record<string, string> = {
  username: "lead.customer_name",
  email: "editClientOriginalData.email",
  clientName: "editClientOriginalData.contact_name",
  clientAddress: "editClientOriginalData.address",
  clientWebsite: "editClientOriginalData.website",
  customerName: "lead.customer_name",
  customerEmail: "lead.customer_email",
  customerPhone: "lead.customer_phone",
  clientId: "lead.client_id",
  createdAt: "lead.created_at",
  collectionVolume: "lead.collection_volume",
  collectionAddress: "lead.collection_address",
  deliveryAddress: "lead.delivery_address",
  materialsTable: "lead.materials_table",
  materialIncluded: "lead.material_included",
  servicesTable: "lead.services_table",
  signature: "lead.signature",
  CName: "lead.customer_name",
  JobRef: "lead.generated_id",
  CompanyName: "editClientOriginalData.company_name",
  CMobile1: "lead.customer_phone",
  JobAddress: "lead.collection_address[0].address",
  CompanyNumber: "editClientOriginalData.phone_number",
  Email: "lead.customer_email",
};
